<template>
  <div class="absolute w-full inset-0 bg_faint flow-root">
    <div class="absolute top-1/5 right-0 left-0 w-full">
      <div class="px-6 mx-4 bg-gray-50 rounded-lg">
        <div class="absolute right-9 top-3" @click="close">
          <close-icon :width="'w-4'"></close-icon>
        </div>
        <div class="pt-8 font-extrabold text-center text-xl">Update your account</div>
        <div class="pt-3">
          <input-text type="text" v-model="first_name" placeholder="First Name"></input-text>
        </div>
        <div class="pt-3">
          <input-text type="text" v-model="last_name" placeholder="Last Name"></input-text>
        </div>
        <div class="pt-3">
          <input-text type="email" v-model="email" placeholder="Email (Optional)"></input-text>
        </div>
        <div class="pt-5">
          <input-text type="text" v-model="address" placeholder="Default Address"></input-text>
        </div>
        <div class="py-5 text-xs" @click="update">
          <input-button>Update Profile</input-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Swal from 'sweetalert2'
import CloseIcon from '../icons/CloseIcon.vue'
import InputButton from '../inputs/InputButton.vue'
import InputText from '../inputs/InputText.vue'
export default {
  components: { InputText, InputButton, CloseIcon },
  props: {
    user_details: Object
  },
  data() {
    return {
      first_name: this.user_details.first_name,
      last_name: this.user_details.last_name,
      email: this.user_details.email,
      address: this.user_details.address
    }
  },
  methods: {
    update() {
      var payload = {
        first_name: this.first_name,
        last_name: this.last_name,
        email: this.email,
        phone: this.user_details.phone,
        address: this.address
      }
      this.$store.dispatch('update', payload).then(() => {
        Swal.fire('Info', 'Profile updated', 'info')
        this.close()
      })
    },
    close() {
      this.$emit('open-edit', false)
    }
  }
}
</script>

<style scoped>
.bg_faint {
  background-color: rgba(0, 0, 0, 0.329);
}
</style>
